import React, { ComponentProps, useState } from 'react';
import { v4 as uuid } from 'uuid';

import { getAssetUrl } from '@utils/utils';
import { useTrans } from '@/custom-hooks/useTrans';

import A11yImage from '@/components/atoms/a11y-image/a11y-image';

import styles from './banner-filler.module.scss';

const REQUIRED_CARD_NUMBER = 136;

export type Card = { id: string; imageUrl: string };
type BannerFillerProps = ComponentProps<'div'> & {
    bannerCards: Card[];
};
export default function BannerFiller(props: BannerFillerProps) {
    const { t } = useTrans();
    const { children, bannerCards } = props;

    const [cardArray] = useState<Card[]>(
        bannerCards?.length < REQUIRED_CARD_NUMBER ? [...bannerCards, ...bannerCards] : bannerCards
    );

    const fixUrl = (url: string) =>
        url.startsWith('/images/')
            ? `https://www.audiokinetic.com${url}`
            : url.replace('/public-images/', '/images/');

    return (
        <>
            <div className={styles.cardsBackgroundContainer}>
                <div className={styles.cardsBackground}>
                    {cardArray.map((card) => (
                        <A11yImage
                            key={`${card.id}|${uuid()}`}
                            className={styles.card}
                            src={getAssetUrl(fixUrl(card.imageUrl))}
                            altText={t('wwise:powered-by-wwise.project-image-alt', {
                                AK_VAR_PROJECT_ID: card.id,
                            })}
                        />
                    ))}
                </div>
                <div className={styles.cardsForeground}>{children}</div>
            </div>
            <div className={styles.bannerBottomBand} />
        </>
    );
}
